import { useCallback, useEffect, useMemo, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Form } from "reactstrap";
import { useMutation } from "react-query";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash, faXmark } from "@fortawesome/free-solid-svg-icons";

import { APIMS } from "../../../../../../config/apims";
import { APISD } from "../../../../../../config/apisd";
import ToastSuccess from "../../../../../NotificationToast/ToastSuccess";
import ToastError from "../../../../../NotificationToast/ToastError";

import "bulma/css/bulma.css";
import "../../../../../../index.css";

const modalStyles = `
  .akses-absen-password-wrap {
    position: relative;
  }

  .akses-absen-password-input {
    padding-right: 48px !important;
  }

  .akses-absen-password-toggle {
    position: absolute;
    top: 50%;
    right: 10px;
    display: inline-flex;
    width: 34px;
    height: 34px;
    align-items: center;
    justify-content: center;
    transform: translateY(-50%);
    border: 0;
    border-radius: 8px;
    background: transparent;
    color: #66718b;
    font-size: 15px;
  }

  .akses-absen-password-toggle:hover {
    background: #f3f5fb;
    color: #34415f;
  }
`;

const initialForm = {
  username: "",
  password: "",
  ysb_branch_id: "",
  ysb_school_id: "",
};

export default function DataAksesAbsenAdd(props) {
  const token = localStorage.getItem("token");
  const idUser = localStorage
    .getItem("id_admin")
    ?.replace(/[|&;$%@"<>()+,]/g, "");

  const [form, setForm] = useState(initialForm);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [loadingCabang, setLoadingCabang] = useState(false);
  const [loadingSekolah, setLoadingSekolah] = useState(false);
  const [getDataCabang, setGetDataCabang] = useState([]);
  const [getSekolah, setGetSekolah] = useState([]);
  const [showPassword, setShowPassword] = useState(false);

  const fetchParams = useMemo(
    () => ({
      headers: {
        Authorization: `${token}`,
        "Content-Type": "application/json",
      },
    }),
    [token]
  );

  const GetResponseCabang = useCallback(async () => {
    setLoadingCabang(true);

    try {
      const response = await APIMS.get(
        "/api/branches?page=1&limit=1000&ascending=1&search=",
        fetchParams
      );

      setGetDataCabang(response?.data?.data || []);
    } catch (error) {
      setGetDataCabang([]);

      ToastError.fire({
        icon: "error",
        title: error?.response?.data?.message || "Gagal memuat data cabang",
      });
    } finally {
      setLoadingCabang(false);
    }
  }, [fetchParams]);

  useEffect(() => {
    GetResponseCabang();
  }, [GetResponseCabang]);

  const GetResponseSekolah = useCallback(async () => {
    if (!form.ysb_branch_id) {
      setGetSekolah([]);
      return;
    }

    setLoadingSekolah(true);

    try {
      const response = await APIMS.get(
        `/api/schools?page=1&limit=1000&ascending=1&search=&branch=${form.ysb_branch_id}`,
        fetchParams
      );

      setGetSekolah(response?.data?.data || []);
    } catch (error) {
      setGetSekolah([]);

      ToastError.fire({
        icon: "error",
        title: error?.response?.data?.message || "Gagal memuat data sekolah",
      });
    } finally {
      setLoadingSekolah(false);
    }
  }, [fetchParams, form.ysb_branch_id]);

  useEffect(() => {
    GetResponseSekolah();
  }, [GetResponseSekolah]);

  const handleChange = (event) => {
    const { name, value } = event.target;

    setForm((previous) => ({
      ...previous,
      [name]: value,
      ...(name === "ysb_branch_id" ? { ysb_school_id: "" } : {}),
    }));
  };

  const handleSubmit = useMutation(async (event) => {
    event.preventDefault();
    setIsSubmitting(true);

    try {
      const response = await APISD.post(
        "/api/absen-auth/store",
        {
          username: form.username,
          password: form.password,
          ysb_branch_id: form.ysb_branch_id,
          ysb_school_id: form.ysb_school_id,
          user_id: idUser,
          token,
        },
        fetchParams
      );

      if (response?.status === 200) {
        ToastSuccess.fire({
          icon: "success",
          title: response?.data?.message || "Data berhasil disimpan",
        });

        props.GetResponseData();
        props.onHide();
      }
    } catch (error) {
      ToastError.fire({
        icon: "error",
        title: error?.response?.data?.message || "Gagal menyimpan data",
      });
    } finally {
      setIsSubmitting(false);
    }
  });

  return (
    <>
      <style>{modalStyles}</style>

      <Modal
        {...props}
        size="md"
        centered
        backdrop="static"
        keyboard={false}
        dialogClassName="module-modal-dialog"
        contentClassName="module-modal-content"
        aria-labelledby="akses-absen-add-title"
      >
        <div className="module-modal-header">
          <div>
            <h5 id="akses-absen-add-title" className="module-modal-title">
              Tambah Akses Absensi
            </h5>
            
          </div>

          <button
            type="button"
            className="module-modal-close"
            onClick={props.onHide}
            aria-label="Tutup modal"
          >
            <FontAwesomeIcon icon={faXmark} />
          </button>
        </div>

        <Form onSubmit={(event) => handleSubmit.mutate(event)}>
          <Modal.Body className="module-modal-body mt-1 mx-2">
            <div className="module-form-grid">
              <div className="module-form-group">
                <label className="module-form-label" htmlFor="add-branch">
                  Cabang <span>*</span>
                </label>
                <select
                  id="add-branch"
                  name="ysb_branch_id"
                  className="module-form-select"
                  value={form.ysb_branch_id}
                  onChange={handleChange}
                  disabled={loadingCabang}
                  required
                >
                  <option value="">
                    {loadingCabang ? "Memuat cabang..." : "Pilih Cabang"}
                  </option>
                  {getDataCabang.map((cabang) => (
                    <option
                      key={cabang?.id || cabang?.branch_code}
                      value={cabang?.branch_code}
                    >
                      {cabang?.branch_name}
                    </option>
                  ))}
                </select>
              </div>

              <div className="module-form-group">
                <label className="module-form-label" htmlFor="add-school">
                  Sekolah <span>*</span>
                </label>
                <select
                  id="add-school"
                  name="ysb_school_id"
                  className="module-form-select"
                  value={form.ysb_school_id}
                  onChange={handleChange}
                  disabled={!form.ysb_branch_id || loadingSekolah}
                  required
                >
                  <option value="">
                    {!form.ysb_branch_id
                      ? "Pilih cabang terlebih dahulu"
                      : loadingSekolah
                      ? "Memuat sekolah..."
                      : "Pilih Sekolah"}
                  </option>
                  {getSekolah
                    .filter(
                      (school) => school?.school_code !== "BASEMENT_BEKASI"
                    )
                    .map((school) => (
                      <option
                        key={school?.id || school?.school_code}
                        value={school?.school_code}
                      >
                        {school?.school_name}
                      </option>
                    ))}
                </select>
              </div>

              <div className="module-form-group module-form-span-2">
                <label className="module-form-label" htmlFor="add-username">
                  Username <span>*</span>
                </label>
                <input
                  id="add-username"
                  type="text"
                  name="username"
                  className="module-form-input"
                  value={form.username}
                  onChange={handleChange}
                  
                  autoComplete="username"
                  required
                />
              </div>

              <div className="module-form-group module-form-span-2">
                <label className="module-form-label" htmlFor="add-password">
                  Password <span>*</span>
                </label>
                <div className="akses-absen-password-wrap">
                  <input
                    id="add-password"
                    type={showPassword ? "text" : "password"}
                    name="password"
                    className="module-form-input akses-absen-password-input"
                    value={form.password}
                    onChange={handleChange}
                    
                    autoComplete="new-password"
                    required
                  />
                  <button
                    type="button"
                    className="akses-absen-password-toggle"
                    onClick={() => setShowPassword((previous) => !previous)}
                    aria-label={
                      showPassword ? "Sembunyikan password" : "Tampilkan password"
                    }
                    title={
                      showPassword ? "Sembunyikan password" : "Tampilkan password"
                    }
                  >
                    <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
                  </button>
                </div>
              </div>
            </div>
          </Modal.Body>

          <div className="module-modal-footer">
            <button
              type="button"
              className="module-modal-cancel"
              onClick={props.onHide}
              disabled={isSubmitting}
            >
              Batal
            </button>
            <button
              type="submit"
              className="module-modal-submit"
              disabled={isSubmitting}
            >
              {isSubmitting && <span className="module-button-spinner" />}
              {isSubmitting ? "Menyimpan..." : "Tambahkan"}
            </button>
          </div>
        </Form>
      </Modal>
    </>
  );
}
